import { NO_PRODUCT_STATIC_MESSAGE, PRODUCTS_ARE_AVAILABLE_STATIC_MESSAGE } from '../constants'

export const checkNoResult = (rightContent) => rightContent
  .find(c => c.name === 'TireResultList').totalNumRecs === 0

export const generateStaticLabel = (totalNumRecs, isTiresTrailerPage) => {
  if (isTiresTrailerPage) return
  return totalNumRecs ? PRODUCTS_ARE_AVAILABLE_STATIC_MESSAGE : NO_PRODUCT_STATIC_MESSAGE
}
